
import { Component, Vue } from "vue-property-decorator";
import MtsTakipHazirlaFormBetaWizard from "@/components/forms/form-wizard/eicrapro/MtsTakipHazirlaFormBetaWizard.vue";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";

@Component({
  components: {
    MtsTakipHazirlaFormBetaWizard,
    UyapBagliDegilView
  }
})
export default class MtsTakipHazirlaBetaView extends Vue {

}
